import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=378c0650&scoped=true"
import script from "./phoneNumber.vue?vue&type=script&lang=js"
export * from "./phoneNumber.vue?vue&type=script&lang=js"
import style0 from "./phoneNumber.vue?vue&type=style&index=0&id=378c0650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378c0650",
  null
  
)

export default component.exports